<template>
<div>

    <v-tabs icons-and-text grow >
        <v-tab>
            Data Pribadi
            <v-icon v-if="statusPerusahaan === 'A'">mdi-check-circle</v-icon>
            <v-icon v-else>mdi-help-circle</v-icon>              
        </v-tab>
        <v-tab>
            Pengalaman
            <v-icon v-if="statusPengalaman === 'A'">mdi-check-circle</v-icon>
            <v-icon v-else>mdi-help-circle</v-icon>  
        </v-tab>
        <v-tab>
            Sertifikat
            <v-icon v-if="statusSertifikat === 'A'">mdi-check-circle</v-icon>
            <v-icon v-else>mdi-help-circle</v-icon>  
        </v-tab>
        <v-tab>
            Sertifikat Vendor
            <v-icon>mdi-help-circle</v-icon>  
        </v-tab>

        <v-tab-item>
            <VerifikasiDataPribadi :vendorId="vendorId" readonly />
            <v-card class="ma-2">
                <template v-if="statusPerusahaan === 'A'">
                    <v-card-text> <v-chip dark color="green"><v-avatar left><v-icon>mdi-checkbox-marked-circle</v-icon></v-avatar>Sudah Verifikasi</v-chip> </v-card-text>
                </template>
                <template v-else>
                    <v-textarea label="Remark: Catatan kekurangan kelengkapan data" v-model="remarkPerusahaan" auto-grow outlined/> 
                    <v-card-actions>
                        <v-btn class="green" dark @click="statusPerusahaan = 'A'; updateStatus()">Verifikasi</v-btn>
                        <v-btn class="red" dark @click="updateRemark()">Data Kurang Lengkap</v-btn>
                    </v-card-actions>
                </template>
            </v-card>
        </v-tab-item>

        <v-tab-item>
            <VerifikasiPengalaman :vendorId="vendorId" readonly />
            <v-card class="ma-2">
                <template v-if="statusPengalaman === 'A'">
                    <v-card-text> <v-chip dark color="green"><v-avatar left><v-icon>mdi-checkbox-marked-circle</v-icon></v-avatar>Sudah Verifikasi</v-chip> </v-card-text>
                </template>
                <template v-else>
                    <v-textarea label="Remark: Catatan kekurangan kelengkapan data" v-model="remarkPengalaman" auto-grow outlined/> 
                    <v-card-actions>
                        <v-btn class="green" dark @click="statusPengalaman = 'A'; updateStatus()">Verifikasi</v-btn>
                        <v-btn class="red" dark @click="updateRemark()">Data Kurang Lengkap</v-btn>
                    </v-card-actions>
                </template>
            </v-card>
        </v-tab-item>

        <v-tab-item>
            <VerifikasiSertifikat :vendorId="vendorId" readonly />
            <v-card class="ma-2">
                <template v-if="statusSertifikat === 'A'">
                    <v-card-text> <v-chip dark color="green"><v-avatar left><v-icon>mdi-checkbox-marked-circle</v-icon></v-avatar>Sudah Verifikasi</v-chip> </v-card-text>
                </template>
                <template v-else>
                    <v-textarea label="Remark: Catatan kekurangan kelengkapan data" v-model="remarkSertifikat" auto-grow outlined/> 
                    <v-card-actions>
                        <v-btn class="green" dark @click="statusSertifikat = 'A'; updateStatus()">Verifikasi</v-btn>
                        <v-btn class="red" dark @click="updateRemark()">Data Kurang Lengkap</v-btn>
                    </v-card-actions>
                </template>
            </v-card>
        </v-tab-item>
        <v-tab-item>
            <div class="pa-2">
            <SertifikatVendor :Id="vendorId"></SertifikatVendor>
            </div>
        </v-tab-item>

    </v-tabs>

    <!-- Notification -->
    <v-snackbar
        v-model="notification.show"
        :color="notification.color"
        :top="true"
        :right="true"
        :timeout=3000
    >
        {{ notification.text }}
    </v-snackbar>

</div>
</template>


<script>

const apiUrl = process.env.VUE_APP_ROOT_API
import axios from 'axios'
import VerifikasiDataPribadi from "./../../views/person/PersonDataPribadi";
import VerifikasiPengalaman from "./../../views/person/PersonPengalamanContent";
import VerifikasiSertifikat from "./../../views/person/PersonSertifikatContent";
import SertifikatVendor from './SertifikatVendor';


export default {
    components: {
        VerifikasiDataPribadi,
        VerifikasiPengalaman,
        VerifikasiSertifikat,
        SertifikatVendor
    }, // components

    
    props: {
        vendorId: {
            type: Number,
            required: true
        }        

    }, // props


    data() {
        return {
            statusPerusahaan: 'N',
            statusPengalaman: 'N',
            statusSertifikat: 'N',
            remarkPerusahaan: "",
            remarkPengalaman: "",
            remarkSertifikat: "",

            notification: {
                show: false,
                color: "success",
                text: ""
            }
        }

    }, // data

    
    watch: {
        vendorId() {
            this.getData();
        },

    }, // watch
    

    mounted() {
        this.getData();
    }, // mounted
    

    methods: {
        updateFromResponseData(data) {
            if (data) {
                this.statusPerusahaan = data.statusPerusahaan;
                this.statusPengalaman = data.statusPengalaman;
                this.statusSertifikat = data.statusSertifikat;
                this.remarkPerusahaan = data.remarkPerusahaan;
                this.remarkPengalaman = data.remarkPengalaman;
                this.remarkSertifikat = data.remarkSertifikat;
            }
        },

        async getData() {
            this.statusPerusahaan = 'N';
            this.statusPengalaman = 'N';
            this.statusSertifikat = 'N';
            this.remarkPerusahaan = "";
            this.remarkPengalaman = "";
            this.remarkSertifikat = "";

            await axios.get(`${apiUrl}/vendor/person/status/${this.vendorId}`)
            .then( (response) => {
                this.updateFromResponseData(response.data);

            }).catch( (error) => {
                console.error(error);
                return error;
            });
        },

        updateStatus() {
            const fdata = {
                vendorId: this.vendorId,
                statusPerusahaan: this.statusPerusahaan,
                statusPengalaman: this.statusPengalaman,
                statusSertifikat: this.statusSertifikat
            };

            axios.put(`${apiUrl}/vendor/person/status/verifikasi`, fdata)
            .then( (response) => {
                this.updateFromResponseData(response.data);

                this.notification = {
                    show: true,
                    color: "success",
                    text: "Status verifikasi vendor berhasil di-update"
                };

            }).catch( (error) => {
                console.error(error);

                this.notification = {
                    show: true,
                    color: "error",
                    text: `Gagal update status verifikasi vendor [${error.message}]`
                }

            });

        },

        updateRemark() {
            const fdata = {
                vendorId: this.vendorId,
                remarkPerusahaan: this.remarkPerusahaan,
                remarkPengalaman: this.remarkPengalaman,
                remarkSertifikat: this.remarkSertifikat
            };

            axios.put(`${apiUrl}/vendor/person/status/remark`, fdata)
            .then( () => {
                this.notification = {
                    show: true,
                    color: "success",
                    text: "Status remark vendor berhasil di-update"
                };

            }).catch( (error) => {
                console.error(error);

                this.notification = {
                    show: true,
                    color: "error",
                    text: `Gagal update status remark vendor [${error.message}]`
                }

            });
        }
    }
}

</script>
